/*
* @Author: Abhi Bhatt
* @Date:   2020-07-14 10:56:04
* @Last Modified by:   abhishek714
* @Last Modified time: 2025-03-20 16:13:30
*/
import axios from 'axios';
import { API_URL,EXTERNAL_API_URL } from '../../constants.js';
import $ from 'jquery';

class UserService {
	async login(formFields) {
		const url = `${API_URL}/login/`;
		const headers = {
			'Content-Type':'multipart/form-data'
		}
		return axios({
			url:url+''+formFields.email+'/'+formFields.password+'/',
			method: 'get',
			crossDomain:true,
			config:{headers:headers}
		}).then(function(response) {
			return response;
		}).catch(function(response) {
			return response;
		});
	}

	async signUp(formFields) {
		const url = `${API_URL}/signup/`;
		const headers = {
			'Content-Type':'multipart/form-data'
		}
		var formValue;
		$.each(formFields,function(key,value){
			if(key!=='conf_password') {
				if(key==='user_email') {
					key = 'email';	
				}
				formValue+= key+'='+value+'&';
			}
			
		});
		formValue = formValue.replace("undefined","");
		return axios({
			url:url+'?'+formValue,
			method: 'get',
			crossDomain:true,
			data: formValue,
			config:{headers:headers}
		}).then(function(response) {
			return response;
		}).catch(function(response) {
			return response;
		});

	}

	async logout() {
		localStorage.clear();
		let response = {'status':200,'response':'success','message':'logout successfully.'};
		return response;
	}

	async forgotPassword(formFields) {
		const url = `${API_URL}/forget-password/${formFields.email}/`;
		const headers = {
			'Content-Type':'multipart/form-data'
		}
		return axios({
			url:url,
			method: 'get',
			crossDomain:true,
			config:{headers:headers}
		}).then(function(response) {
			return response;
		}).catch(function(response) {
			return response;
		});
	}

	async resetPassword(resetPasswordToken,formFields) {
		const url = `${API_URL}/reset-password/${resetPasswordToken}/${formFields.encrypted_password}/`;
		const headers = {
			'Content-Type':'multipart/form-data'
		}
		return axios({
			url:url,
			method: 'get',
			crossDomain:true,
			config:{headers:headers}
		}).then(function(response) {
			return response;
		}).catch(function(response) {
			return response;
		});
	}

	async confirmation(email) {
		const url = `${API_URL}/send-confirmation/${email}/`;
		const headers = {
			'Content-Type':'multipart/form-data'
		}
		return axios({
			url:url,
			method: 'get',
			crossDomain:true,
			config:{headers:headers}
		}).then(function(response) {
			return response;
		}).catch(function(response) {
			return response;
		});
	}

	async sendConfirmation(confirmationToken) {
		const url = `${API_URL}/active-user/${confirmationToken}/`;
		const headers = {
			'Content-Type':'multipart/form-data'
		}
		return axios({
			url:url,
			method: 'get',
			crossDomain:true,
			config:{headers:headers}
		}).then(function(response) {
			return response;
		}).catch(function(response) {
			return response;
		});
	}

	async sendSupportEmail(name, email, message) {
		const url = `${API_URL}/send-support-email/`;
		const headers = {
			'Content-Type': 'application/json',
		};
	
		return axios({
			url: url,
			method: 'post',
			data: JSON.stringify({ name, email, message }),
			headers: headers,
		})
		.then(function (response) {
			return response.data;
		})
		.catch(function (error) {
			return error.response ? error.response.data : { error: 'Unknown error' };
		});
	}
	

	async updateProfile(data) {
		const url = `${API_URL}/new-update-profile/`;
		const headers = {
			'Content-Type':'multipart/form-data'
		}
		const formData = new FormData();
    
	    // Append all valid data fields dynamically
	    Object.keys(data).forEach(key => {
	        if (data[key] !== undefined && data[key] !== null) {
	            formData.append(key, data[key]);
	        }
	    });
		
		return axios({
			url:url,
			method: 'post',
			crossDomain:true,
			config:{headers:headers},
			data:formData
		}).then(function(response) {
			return response;
		}).catch(function(response) {
			return response;
		});
	}

	async getOrderHistory(data) {
		const url = `${EXTERNAL_API_URL}/get-order-history/`;
		return axios({
			url:url,
			method: 'post',
			crossDomain:true,
			data:data
		}).then(function(response) {
			return response;
		}).catch(function(response) {
			return response;
		});
	}

	async newSignUp(data) {
		const url = `${API_URL}/new-signup/`;
		const formData = new FormData();
		Object.keys(data).forEach(key => {
			formData.append(key, data[key]);
		});
		return axios({
			url:url,
			method: 'post',
			crossDomain:true,
			data:formData
		}).then(function(response) {
			return response;
		}).catch(function(response) {
			return response;
		});
	}

	async newLogin(formFields) {
		const url = `${API_URL}/new-login/`;
		const headers = {
			'Content-Type':'multipart/form-data'
		}
		
		return axios({
			url:url+''+formFields.email+'/'+formFields.password+'/',
			method: 'get',
			crossDomain:true,
			config:{headers:headers}
		}).then(function(response) {
			return response;
		}).catch(function(response) {
			return response;
		});
	}

	async isExist(data) {
		const url = `${API_URL}/is-exist`;
		return axios({
			url:url,
			method: 'post',
			crossDomain:true,
			data:data
		}).then(function(response) {
			return response;
		}).catch(function(response) {
			return response;
		});
	}

	async getInvitationData(data) {
		const url = `${API_URL}/get-invitation-data`;
		return axios({
			url:url,
			method: 'post',
			crossDomain:true,
			data:data
		}).then(function(response) {
			return response;
		}).catch(function(response) {
			return response;
		});
	}

	async getTeamMembers(user_id) {
		const url = `${API_URL}/get-team-members/${user_id}/`;
		const headers = {
			'Content-Type':'multipart/form-data'
		}
		return axios({
			url:url,
			method: 'get',
			crossDomain:true,
			config:{headers:headers}
		}).then(function(response) {
			return response;
		}).catch(function(response) {
			return response;
		});
	}

	async inviteUser(data) {
		const url = `${API_URL}/invite-user`;
		const formData = new FormData();
		Object.keys(data).forEach(key => {
			formData.append(key, data[key]);
		});
		return axios({
			url:url,
			method: 'post',
			crossDomain:true,
			data:formData
		}).then(function(response) {
			return response;
		}).catch(function(response) {
			return response;
		});
	}

	async resendInvite(data) {
		const url = `${API_URL}/resend-invite`;
		return axios({
			url:url,
			method: 'post',
			crossDomain:true,
			data:data
		}).then(function(response) {
			return response;
		}).catch(function(response) {
			return response;
		});
	}

	async getPoFiles(user_id) {
		const url = `${API_URL}/get-pofiles/${user_id}/`;
		return axios({
			url:url,
			method: 'get',
			crossDomain:true,
		}).then(function(response) {
			return response;
		}).catch(function(response) {
			return response;
		});
	}

	async uploadPoFiles(files, userId) {
		const url = `${API_URL}/upload-pofiles`;
		let formData = new FormData();
		formData.append("user_id", userId);
		files.forEach((file) => {
			formData.append("files", file); // Append each file
		});

		return axios({
			url: url,
			method: "post",
			data: formData,
			headers: {
				"Content-Type": "multipart/form-data",
			},
			crossDomain:true,
		}).then(function(response) {
			return response;
		}).catch(function(response) {
			return response;
		});
	}

	async removeUser(data) {
		const url = `${API_URL}/remove-user`;
		return axios({
			url: url,
			method: "post",
			data: data,
			crossDomain:true,
		}).then(function(response) {
			return response;
		}).catch(function(response) {
			return response;
		});
	}

	async getUserData(user_id) {
		const url = `${API_URL}/get-user-data/${user_id}/`;
		return axios({
			url:url,
			method:'get',
			crossDomain:true
		}).then(function(response) {
			return response;
		}).catch(function(response) {
			return response;
		});
	}

	async updateMemberData(data) {
		const url = `${API_URL}/update-member-data`;
		return axios({
			url: url,
			method: "post",
			data: data,
			crossDomain:true,
		}).then(function(response) {
			return response;
		}).catch(function(response) {
			return response;
		});
	}
}
export default UserService;